/**
 * @file hooks/useNormailzeClass
 * @copyright 2019 CBC/Radio-Canada. All rights reserved.
 * @author Phil Tietjen [phil.tietjen@cbc.ca]
 */
import { useMemo } from "react";
import { normalizeClass } from "../../utils/path/library";

/**
 * A hook binding for the normalizeClass util function
 * @param {string} [prefix]
 * @param {string} className
 * @param {string} [suffix]
 * @param {boolean} [shouldSlugify]
 *
 * @returns {string} memoized slugified string value.
 */
function useNormalizeClass(
    prefix = "",
    className = "",
    suffix = "",
    shouldSlugify = true
) {
    const normalizedClass = useMemo(() => {
        return normalizeClass(prefix, className, suffix, shouldSlugify);
    }, [prefix, className, suffix, shouldSlugify]);

    return normalizedClass;
}

export default useNormalizeClass;
